import { useNavigate } from 'react-router-dom';
import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import '../styles/pages/_session.scss';

const runSteps = [
  {
    number: 1,
    title: 'Beach Warm-Up',
    description: 'Begin with gentle movements to prepare your body for the sandy terrain. Focus on ankle stability and balance.'
  },
  {
    number: 2,
    title: 'Rhythm of the Waves',
    description: 'Let the sound of waves guide your pace. Run in harmony with the ocean\'s natural rhythm.'
  },
  {
    number: 3,
    title: 'Sand Adaptation',
    description: 'Adjust your stride for the softer surface. The extra resistance builds strength while being gentle on joints.'
  },
  {
    number: 4,
    title: 'Ocean Mindfulness',
    description: 'Breathe in the fresh sea air and let the coastal scenery inspire your run. Stay present in each step.'
  }
];

const OutdoorRunSession2: React.FC = () => {
  const navigate = useNavigate();
  const { isDarkMode } = useTheme();

  const handleFinish = async () => {
    const token = localStorage.getItem('token');
    const session = {
      title: 'Outdoor Run Session 2',
      description: 'Completed Outdoor Run Session 2.',
      image: require('../assets/outdoor-run.png').default || require('../assets/outdoor-run.png'),
      };
      try {
        console.log('Posting session to backend:', session);
        const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/completed-sessions`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(session)
        });
        const result = await response.json();
      } catch (err) {

      }
      navigate('/panel/dashboard/outdoor-run'); // Navigate to outdoor run section
    };

  return (
    <div className={`session-page ${isDarkMode ? 'dark' : ''}`}>
      <div className="session-container">
        <header className="session-header">
          <a
            className="session-back-link"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              navigate(-1);
            }}
            title="Go back"
          >
            <span className="session-back-icon material-symbols-outlined">arrow_back</span>
          </a>
        </header>

        <main className="session-main">
          <div className="session-content-grid">
            {/* Video Section */}
            <div className="session-video-section">
              <h1 className="session-title">Session 2: Beach Coastal Run</h1>
              <p className="session-description">
                Experience the therapeutic rhythm of running along a beautiful coastline. Feel the sand beneath your feet and the ocean breeze on your skin.
              </p>
              <div className="session-video-wrapper">
                <iframe
                  className="session-video"
                  src="https://www.youtube.com/embed/BKnvF9G5pG8"
                  title="Session 2: Outdoor Run"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            </div>

            {/* Instructions Section */}
            <div className="session-instructions-section">
              <div className="session-instructions-card">
                <h2 className="session-instructions-title">How to Enjoy Your Run</h2>
                <div className="session-steps">
                  {runSteps.map((step) => (
                    <div key={step.number} className="session-step">
                      <div className="session-step-number">
                        {step.number}
                      </div>
                      <div className="session-step-content">
                        <h3 className="session-step-title">{step.title}</h3>
                        <p className="session-step-description">{step.description}</p>
                      </div>
                    </div>
                  ))}
                </div>

                <button
                  className="session-complete-btn"
                  onClick={handleFinish}
                >
                  <span className="session-complete-icon material-symbols-outlined">check_circle</span>
                  Mark Session as Complete
                </button>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default OutdoorRunSession2;

